<template>
  <div class="my-3">
    <label>Edit Clients</label>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 col-lg-12 border p-3">
        <div class="row">
          <div class="col-sm-12 col-lg-5 col-md-5 my-2">
            <p>Select a location or company to administer:</p>
          </div>
          <div class="col-sm-12 col-lg-5 col-md-5 my-2">
            <b-form-select v-model="SelectCompany">
              <option
                v-for="Company in SelectCompanyOptions"
                :value="Company"
                :key="Company.value"
              >
                {{ Company.text }}
              </option>
            </b-form-select>
          </div>
        </div>
        <b-button
          variant="primary"
          class="btn-lg btn-sm-block my-2"
          :to="{
            name: 'AdminPointProgramsEditActivePrograms',
            params: { clientData: SelectCompany },
          }"
          :disabled="!SelectCompany"
          @click.native="scrollToTop"
        >
          Edit Programs/contests for this location
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PointProgramsEditClients",

  components: {},

  data() {
    return {
      SelectCompany: null,
      SelectCompanyOptions: [],
    };
  },

  methods: {
    setMessage: function () {
      this.$store.dispatch("systemMessage/setMessage", {
        message: "",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    editActivePrograms: function () {
      console.log("hello");
    },
  },

  computed: {
    authorizedClients() {
      return this.$store.getters["adminPointPrograms/getAuthorizedClients"];
    },
  },

  watch: {
    authorizedClients(authorizedClients) {
      var datas = [];
      authorizedClients.map(function (data) {
        datas.push({
          value: data.clientId,
          text: data.clientName,
        });
      });

      //   this.SelectCompany = datas.length > 0 ? datas[0].value : null;
      this.SelectCompanyOptions = datas;
    },
  },

  created() {
    this.setMessage();
    this.$store.dispatch("adminPointPrograms/fetchAuthorizedClients");
  },
};
</script>

<style lang="scss" scoped>
</style>
